export const LANGUAGE_MAP = {
    'JavaScript': 'javascript',
    'Python': 'python',
    'TypeScript': 'typescript',
    'C++': 'cpp',
    'Java': 'java',
    'Go': 'go',
    'Ruby': 'ruby',
    'Rust': 'rust',
    'C#': 'csharp',
}